import axios from 'axios';
import { logOut } from '../helpers/functions';

const apiURL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: apiURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && ((error.response.status === 401 && window.location.pathname !== '/login') || error.response.status === 403)) {
      logOut();
    }
    return Promise.reject(error);
  },
);

export default api;